import React, { Suspense } from "react";
import { ContentRoute, LayoutSplashScreen } from "../../../_metronic/layout";
import { Redirect, Switch } from "react-router-dom";
import { HyperParamsManagementPageNew } from "./component/HyperParamsManagementPage";

function HyperParamsManagementNew() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          <Redirect
            exact={true}
            from="/user/hyperParams"
            to="/user/hyperParams/hyperParamsManagementPage"
          />
        }
        <ContentRoute
          path="/user/hyperParams/hyperParamsManagementPage"
          component={HyperParamsManagementPageNew}
        />
      </Switch>
    </Suspense>
  );
}
export default HyperParamsManagementNew;
